import { put, call, takeLatest } from 'redux-saga/effects'

import { PROPERTY_NAME_PARAM } from 'Constants'
import {
  createTag as createPropertyNameApi,
  deleteTag as deletePropertyNameApi,
  getTags as getPropertyNamesApi,
} from 'Service/Api'

import * as PropertyNameTypes from 'Redux/Types/PropertyNameTypes'
import * as PropertyNameActions from 'Redux/Actions/PropertyNameActions'

function* deletePropertyName({ payload }) {
  try {
    yield call(deletePropertyNameApi, payload)
    yield put(PropertyNameActions.deletePropertyNameSucceeded(payload))
  } catch (errors) {
    yield put(PropertyNameActions.deletePropertyNameFailed(errors))
  }
}

function* getPropertyNames() {
  try {
    const { data } = yield call(getPropertyNamesApi, PROPERTY_NAME_PARAM)
    yield put(PropertyNameActions.getPropertyNamesSucceeded(data))
  } catch (errors) {
    yield put(PropertyNameActions.getPropertyNamesFailed(errors))
  }
}

function* createPropertyName({ payload }) {
  const { searchTerm, resolve, reject } = payload
  const params = {
    value: searchTerm,
    type: { name: PROPERTY_NAME_PARAM },
  }
  try {
    const { data } = yield call(createPropertyNameApi, params)
    yield put(PropertyNameActions.addPropertyNameSucceeded(data))
    if (resolve) {
      resolve(data)
    }
  } catch (errors) {
    yield put(PropertyNameActions.addPropertyNameFailed(errors))
    if (reject) {
      reject(errors)
    }
  }
}

export default function* ExpenseCategorySaga() {
  yield takeLatest(PropertyNameTypes.DELETE_PROPERTY_NAME, deletePropertyName)
  yield takeLatest(PropertyNameTypes.GET_PROPERTY_NAMES, getPropertyNames)
  yield takeLatest(PropertyNameTypes.ADD_PROPERTY_NAME, createPropertyName)
}
